import { StartClient } from '@tanstack/react-start/client';
import { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import './index.css';
import { getRouter } from './router';

const AnyStartClient = StartClient as any;

hydrateRoot(
  document,
  <StrictMode>
    <AnyStartClient router={getRouter()} />
  </StrictMode>
);
